import { t } from "../../translations";
import "../styles/terms-services.css";

const TermsService = ({ lang }) => {
  return (
    <div className="servicesTerms_body">
      <h1>{t("terms_service_page.main_title", lang)}</h1>

      <p>{t("terms_service_page.intro_para1", lang)}</p>

      <p>{t("terms_service_page.intro_para2", lang)}</p>

      <p>{t("terms_service_page.intro_para3", lang)}</p>

      <h2 className="h2-title">
        {t("terms_service_page.service_description.title", lang)}
      </h2>

      <p>{t("terms_service_page.service_description.para1", lang)}</p>

      <p>{t("terms_service_page.service_description.para2", lang)}</p>

      <p>{t("terms_service_page.service_description.para3", lang)}</p>

      <p>{t("terms_service_page.service_description.para4", lang)}</p>

      <p>{t("terms_service_page.service_description.para5", lang)}</p>

      <h2 className="h2-title">
        {t("terms_service_page.service_access.title", lang)}
      </h2>

      <p>{t("terms_service_page.service_access.para1", lang)}</p>

      <p>{t("terms_service_page.service_access.para2", lang)}</p>

      <p>{t("terms_service_page.service_access.para3", lang)}</p>

      <p>{t("terms_service_page.service_access.para4", lang)}</p>

      <p>{t("terms_service_page.service_access.para5", lang)}</p>

      <p>{t("terms_service_page.service_access.para6", lang)}</p>

      <h2 className="h2-title">
        {t("terms_service_page.terms_of_use.title", lang)}
      </h2>

      <p>{t("terms_service_page.terms_of_use.intro", lang)}</p>

      <p>{t("terms_service_page.terms_of_use.examples_intro", lang)}</p>

      <p>
        <strong>a)</strong> {t("terms_service_page.terms_of_use.item_a", lang)}
      </p>

      <p>
        <strong>b)</strong> {t("terms_service_page.terms_of_use.item_b", lang)}
      </p>

      <p>
        <strong>c)</strong> {t("terms_service_page.terms_of_use.item_c", lang)}
      </p>

      <p>
        <strong>d)</strong> {t("terms_service_page.terms_of_use.item_d", lang)}
      </p>

      <p>
        <strong>e)</strong> {t("terms_service_page.terms_of_use.item_e", lang)}
      </p>

      <p>
        <strong>f)</strong> {t("terms_service_page.terms_of_use.item_f", lang)}
      </p>

      <p>
        <strong>g)</strong> {t("terms_service_page.terms_of_use.item_g", lang)}
      </p>

      <p>
        <strong>h)</strong> {t("terms_service_page.terms_of_use.item_h", lang)}
      </p>

      <p>
        <strong>i)</strong> {t("terms_service_page.terms_of_use.item_i", lang)}
      </p>

      <p>
        <strong>j)</strong> {t("terms_service_page.terms_of_use.item_j", lang)}
      </p>

      <p>
        <strong>k)</strong> {t("terms_service_page.terms_of_use.item_k", lang)}
      </p>

      <h2 className="h2-title">
        {t("terms_service_page.ingredients_allergens.title", lang)}
      </h2>

      <p>{t("terms_service_page.ingredients_allergens.content", lang)}</p>

      <h2 className="h2-title">
        {t("terms_service_page.vendor_insurance.title", lang)}
      </h2>

      <p>{t("terms_service_page.vendor_insurance.para1", lang)}</p>

      <h2 className="h2-title">
        {t("terms_service_page.customer_reviews.title", lang)}
      </h2>

      <p>{t("terms_service_page.customer_reviews.content", lang)}</p>

      <h2 className="h2-title">
        {t("terms_service_page.marketplace_risk.title", lang)}
      </h2>

      <p>{t("terms_service_page.marketplace_risk.content", lang)}</p>

      <h2 className="h2-title">
        {t("terms_service_page.vendors_as_independent.title", lang)}
      </h2>

      <p>{t("terms_service_page.vendors_as_independent.para1", lang)}</p>

      <p>{t("terms_service_page.vendors_as_independent.para2", lang)}</p>

      <h2 className="h2-title">
        {t("terms_service_page.international_use.title", lang)}
      </h2>

      <p>{t("terms_service_page.international_use.content", lang)}</p>

      <h2 className="h2-title">
        {t("terms_service_page.commercial_use.title", lang)}
      </h2>

      <p>{t("terms_service_page.commercial_use.content", lang)}</p>

      <h2 className="h2-title">
        {t("terms_service_page.identity_verification.title", lang)}
      </h2>

      <p>{t("terms_service_page.identity_verification.content", lang)}</p>

      <h2 className="h2-title">
        {t("terms_service_page.user_representations.title", lang)}
      </h2>

      <p>
        {t("terms_service_page.user_representations.all_users_title", lang)}
      </p>

      <ul>
        <li>
          {t(
            "terms_service_page.user_representations.all_users_items.item1",
            lang
          )}
        </li>
        <li>
          {t(
            "terms_service_page.user_representations.all_users_items.item2",
            lang
          )}
        </li>
        <li>
          {t(
            "terms_service_page.user_representations.all_users_items.item3",
            lang
          )}
        </li>
        <li>
          {t(
            "terms_service_page.user_representations.all_users_items.item4",
            lang
          )}
        </li>
        <li>
          {t(
            "terms_service_page.user_representations.all_users_items.item5",
            lang
          )}
        </li>
        <li>
          {t(
            "terms_service_page.user_representations.all_users_items.item6",
            lang
          )}
        </li>
        <li>
          {t(
            "terms_service_page.user_representations.all_users_items.item7",
            lang
          )}
        </li>
        <li>
          {t(
            "terms_service_page.user_representations.all_users_items.item8",
            lang
          )}
        </li>
        <li>
          {t(
            "terms_service_page.user_representations.all_users_items.item9",
            lang
          )}
        </li>
      </ul>

      <p>{t("terms_service_page.user_representations.vendors_title", lang)}</p>

      <ul>
        <li>
          {t(
            "terms_service_page.user_representations.vendors_items.item1",
            lang
          )}
        </li>
        <li>
          {t(
            "terms_service_page.user_representations.vendors_items.item2",
            lang
          )}
        </li>
        <li>
          {t(
            "terms_service_page.user_representations.vendors_items.item3",
            lang
          )}
        </li>
        <li>
          {t(
            "terms_service_page.user_representations.vendors_items.item4",
            lang
          )}
        </li>
        <li>
          {t(
            "terms_service_page.user_representations.vendors_items.item5",
            lang
          )}
        </li>
        <li>
          {t(
            "terms_service_page.user_representations.vendors_items.item6",
            lang
          )}
        </li>
        <li>
          {t(
            "terms_service_page.user_representations.vendors_items.item7",
            lang
          )}
        </li>
        <li>
          {t(
            "terms_service_page.user_representations.vendors_items.item8",
            lang
          )}
        </li>
        <li>
          {t(
            "terms_service_page.user_representations.vendors_items.item9",
            lang
          )}
        </li>
        <li>
          {t(
            "terms_service_page.user_representations.vendors_items.item10",
            lang
          )}
        </li>
        <li>
          {t(
            "terms_service_page.user_representations.vendors_items.item11",
            lang
          )}
        </li>
        <li>
          {t(
            "terms_service_page.user_representations.vendors_items.item12",
            lang
          )}
        </li>
        <li>
          {t(
            "terms_service_page.user_representations.vendors_items.item13",
            lang
          )}
        </li>
        <li>
          {t(
            "terms_service_page.user_representations.vendors_items.item14",
            lang
          )}
        </li>
        <li>
          {t(
            "terms_service_page.user_representations.vendors_items.item15",
            lang
          )}
        </li>
        <li>
          {t(
            "terms_service_page.user_representations.vendors_items.item16",
            lang
          )}
        </li>
        <li>
          {t(
            "terms_service_page.user_representations.vendors_items.item17",
            lang
          )}
        </li>
        <li>
          {t(
            "terms_service_page.user_representations.vendors_items.item18",
            lang
          )}
        </li>
        <li>
          {t(
            "terms_service_page.user_representations.vendors_items.item19",
            lang
          )}
        </li>
      </ul>

      <h2 className="h2-title">
        {t("terms_service_page.transaction_fees.title", lang)}
      </h2>

      <p>{t("terms_service_page.transaction_fees.para1", lang)}</p>

      <h3>
        {t("terms_service_page.transaction_fees.taxes_section.title", lang)}
      </h3>

      <p>
        {t("terms_service_page.transaction_fees.taxes_section.para1", lang)}
      </p>

      <p>
        {t("terms_service_page.transaction_fees.taxes_section.para2", lang)}
      </p>

      <p>
        {t("terms_service_page.transaction_fees.taxes_section.para3", lang)}
      </p>

      <h3>
        {t("terms_service_page.transaction_fees.packaging_section.title", lang)}
      </h3>

      <p>
        {t("terms_service_page.transaction_fees.packaging_section.para1", lang)}
      </p>

      <h3>
        {t("terms_service_page.transaction_fees.payments_section.title", lang)}
      </h3>

      <p>
        {t("terms_service_page.transaction_fees.payments_section.para1", lang)}
      </p>

      <p>
        {t("terms_service_page.transaction_fees.payments_section.para2", lang)}
      </p>

      <h3>
        {t(
          "terms_service_page.transaction_fees.fee_changes_section.title",
          lang
        )}
      </h3>

      <p>
        {t(
          "terms_service_page.transaction_fees.fee_changes_section.para1",
          lang
        )}
      </p>

      <h3>
        {t(
          "terms_service_page.transaction_fees.promotions_section.title",
          lang
        )}
      </h3>

      <p>
        {t(
          "terms_service_page.transaction_fees.promotions_section.para1",
          lang
        )}
      </p>

      <p>
        <strong>{t("terms_service_page.last_revised", lang)}</strong>
      </p>
    </div>
  );
};

export default TermsService;
